import { FilterDrawer } from 'libs/searchspring/components/collection/filters/FilterDrawer'
import { Divider } from 'libs/searchspring/components/collection/Divider'
import { FilterSort } from 'libs/searchspring/components/collection/filters/FilterSort'
import { NestedCollections } from 'libs/searchspring/components/collection/NestedCollections'

export const CollectionToolbar = ({ GridSelector, setRef }) => {
  return (
    <div ref={setRef} className={'has-[[data-ui="visible"][data-id="filters"]]:z-[60] z-40 flex flex-col-reverse items-start justify-center border-t md:px-2 md:flex-row md:items-center md-max:flex-wrap md:justify-between md:gap-32 border-neutral-medium'}>
      <div className={'flex-items-center'}>
        <FilterDrawer />
        <Divider />
        <FilterSort />
        <Divider />
        <GridSelector />
      </div>
      <div className={'w-full'}>
        <NestedCollections />
      </div>
    </div>
  )
}
